import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';

import Snackbar from '../../../labels/Snackbar';
import BlueButton from '../../../buttons/BlueButton';

class MenuValue extends React.Component {
    state = {
        report_lot: undefined,
        value: '',
    };

    static getDerivedStateFromProps(props, state) {
        const { report_lot, info } = props;
        if (report_lot !== state.report_lot || info !== state.info) {
            state.report_lot = report_lot;
            state.local = report_lot ? report_lot.local : undefined;
            state.from = report_lot ? report_lot.from : undefined;
            state.to = report_lot ? report_lot.to : undefined;
            state.type = report_lot ? report_lot.type : undefined;
            state.value = report_lot ? report_lot.value : '';
            state.info = info;
            state.nodes =
                info && info.security && info.security.locals && info.security.locals.length > 0
                    ? info.security.locals.reduce((arr, c) => {
                        if (
                            info.security.localPermits[c.id] &&
                            info.security.localPermits[c.id].length > 0
                        ) {
                            arr.push(c);
                        }
                        return arr;
                    }, [])
                    : [];
            return state;
        }
        return null;
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleSearch = (event) => {
        const { local, from, to, type, value } = this.state;
        if (value && type) {
            this.props
                .loadLotTempValues(from, to, local, type, value)
                .then(() => this.props.history.push('/reports/lot/result'))
                .catch((error) => {
                    this.setState({ error: error.message, errorType: error.type });
                });
        }
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleCloseError = () => {
        this.setState({ error: '' });
    };

    render() {
        const { local, from, to, type, nodes, value, error, errorType } = this.state;
        const { intl } = this.props;
        return (
            <div className={'padding_bottom_9 width50'}>
                <div className="padding_borders_flat">
                    <div className="flex_full_row align_center margin_bottom_12">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'type_label_local' })}
                            </InputLabel>
                            <Select
                                native
                                value={local}
                                onChange={this.handleChange}
                                inputProps={{ name: 'local', id: 'local-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {nodes &&
                                    nodes
                                        .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                        .map((cat) => {
                                            return (
                                                <option key={randomstring()} value={cat.id}>
                                                    {cat.name}
                                                </option>
                                            );
                                        })}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="flex_full_row align_center margin_bottom_12">
                        <TextField
                            fullWidth
                            name={'from'}
                            id={'from-date'}
                            label={intl.formatMessage({ id: 'form_field_add_date_init_label' })}
                            type="date"
                            defaultValue={from}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="flex_full_row align_center margin_bottom_12">
                        <TextField
                            fullWidth
                            name={'to'}
                            id={'to-date'}
                            label={intl.formatMessage({ id: 'form_field_add_date_end_label' })}
                            type="date"
                            defaultValue={to}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="flex_full_row align_center margin_bottom_12">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'form_field_name_tipo' })}
                            </InputLabel>
                            <Select
                                native
                                value={type}
                                onChange={this.handleChange}
                                inputProps={{ name: 'type', id: 'type-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                <option key={randomstring()} value={'lote'}>
                                    {intl.formatMessage({ id: 'report_search_lot' })}
                                </option>
                                <option key={randomstring()} value={'temp'}>
                                    {intl.formatMessage({ id: 'report_search_temp' })}
                                </option>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="flex_full_row align_center margin_bottom_12">
                        <TextField
                            fullWidth
                            name={'value'}
                            id={'value'}
                            label={intl.formatMessage({ id: 'value' })}
                            value={value}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <BlueButton noValid={!value || !type} id="search" onClick={this.handleSearch} />
                </div>
                {error && (
                    <Snackbar
                        open={true}
                        variant={errorType ?  errorType : "error"}
                        text={error}
                        onClose={this.handleCloseError.bind(this)}
                    />
                )}
            </div>
        );
    }
}

MenuValue.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(MenuValue);



// WEBPACK FOOTER //
// ./src/components/complex/reports/lot/Menu.js